module.exports = __webpack_public_path__ + "img/cta_centered.af07a5d9.png";